import { Injectable } from "@angular/core";
import { StringUtilsHelper } from "./strings.helper";
import { WorkplaceStorageService } from "../../services/local/workplaces-storage.service";

@Injectable({
    providedIn: 'root'
})
export class AgeHelper {
    protected static hour: Map<string, string> = new Map().set("es", "hora de edad").set("en", "hour old").set("pt", "hora de idade");
    protected static hours: Map<string, string> = new Map().set("es", "horas de edad").set("en", "hours old").set("pt", "horas de idade");
    protected static day: Map<string, string> = new Map().set("es", "día de edad").set("en", "day old").set("pt", "dia de idade");
    protected static days: Map<string, string> = new Map().set("es", "días de edad").set("en", "days old").set("pt", "dias de idade");
    protected static month: Map<string, string> = new Map().set("es", "mes").set("en", "month old").set("pt", "mês de idade");
    protected static months: Map<string, string> = new Map().set("es", "meses").set("en", "months old").set("pt", "meses");
    protected static year: Map<string, string> = new Map().set("es", "año").set("en", "year old").set("pt", "ano");
    protected static years: Map<string, string> = new Map().set("es", "años").set("en", "years old").set("pt", "anos");

    static getAgeComplete(birthdate : Date){
        let language = WorkplaceStorageService.getLanguageCve();
        let ageString: string = "";
        if (birthdate) {
            const convertAge = StringUtilsHelper.getAgeExactNumber(birthdate);

            if (convertAge.years && convertAge.years > 0) {
                if (convertAge.years === 1)
                    ageString = convertAge.years + " " + this.year.get(language);
                else
                    ageString = convertAge.years + " " + this.years.get(language);
            } else if (convertAge.months && convertAge.months) {
                if (convertAge.months === 1)
                    ageString = convertAge.months + " " + this.month.get(language);
                else
                    ageString = convertAge.months + " " + this.months.get(language);
            } else if (convertAge.days && convertAge.days > 0) {
                if (convertAge.days === 1)
                    ageString = convertAge.days + " " + this.day.get(language);
                else
                    ageString = convertAge.days + " " + this.days.get(language);
            } else if (convertAge.hours && convertAge.hours > 0) {
                if (convertAge.hours === 1)
                    ageString = convertAge.hours + " " + this.hour.get(language);
                else
                    ageString = convertAge.hours + " " + this.hours.get(language);
            }
        }
        return ageString;
    }
}